import { useMemo } from 'react';
import { ConfigSvcProps } from '..';

export const useHideSvc = (props: ConfigSvcProps) => {
  const { jobOptionSvc, isRequired, isSku } = props;

  const hideSvc = useMemo(() => {
    if (
      Boolean(
        isRequired &&
          !jobOptionSvc?.options &&
          (!jobOptionSvc?.specs || jobOptionSvc.specs?.length <= 1) &&
          !jobOptionSvc?.showInstructions
      ) &&
      !isSku
    ) {
      return { display: 'none' };
    } else {
      return { display: 'block' };
    }
  }, [isRequired, jobOptionSvc, isSku]);

  return hideSvc;
};
